import { Logger } from './Logger';

export enum BetStatusWatcherStates {
  AllAccepted = 0b1,
  SomeAccepted = 0b10,
  NoneAccepted = 0b100,
}

const enum BetStatusWatcherContext {
  Premature = 0b1,
}

// provide 4 bits for context flags
const CONTEXT_SHIFT = 4;

class BetStatusWatcherBase {
  private state: number = 0b0;

  constructor() {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        this.logState(true);
      }
    });
  }

  public reset(): void {
    this.state = 0;
  }

  public setState(state: BetStatusWatcherStates): void {
    this.state |= state;
  }

  logState(premature?: boolean): void {
    // If there is no state, do nothing
    if (!this.state) return;

    // Add context flags
    let fullState = this.state << CONTEXT_SHIFT;
    if (premature) {
      fullState |= BetStatusWatcherContext.Premature;
    }

    Logger.logEvent('betStatus', {
      bandwidth: fullState,
      instant: premature,
    });
    this.reset();
  }
}

export const BetStatusWatcher = new BetStatusWatcherBase();
